export const resetOktaPassword = ({ token, userId }) => ({
  HTTPMethod: "POST",
  path: `/api/v1/sso/users/${userId}/reset-password`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
